// Power Dial trigger — drop-in button for the Leads bulk-action bar and the
// Sales Pipeline column header. Opens PowerDialModal pre-loaded with the
// supplied lead IDs.

import React from 'react';
import { Zap } from 'lucide-react';
import { usePowerDial } from '../state/powerDial.js';

export default function PowerDialButton({ leadIds = [], leads = [], compact = false, label }) {
  const { openModal } = usePowerDial();
  const count = leadIds.length;

  const onClick = () => {
    if (!count) return;
    const index = {};
    for (const l of leads || []) {
      if (l?._id) index[l._id] = { firstName: l.firstName, lastName: l.lastName, phone: l.phone };
    }
    openModal(leadIds, index);
  };

  if (compact) {
    return (
      <button
        type="button"
        onClick={onClick}
        disabled={!count}
        className="px-2.5 py-1.5 rounded-md text-xs font-semibold text-white
                   bg-linear-to-r from-[#7C3AED] to-[#E040FB]
                   hover:shadow-md hover:shadow-[#7C3AED]/40
                   disabled:opacity-50 disabled:cursor-not-allowed transition flex items-center gap-1"
        title={count ? `Power Dial ${count} leads` : 'Select leads to enable'}
      >
        <Zap className="w-3.5 h-3.5" />
        Power Dial{count ? ` (${count})` : ''}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={!count}
      className="px-4 py-2 rounded-lg text-sm font-bold text-white
                 bg-linear-to-r from-[#7C3AED] to-[#E040FB]
                 hover:shadow-lg hover:shadow-[#7C3AED]/40
                 disabled:opacity-60 disabled:cursor-not-allowed transition flex items-center gap-2"
    >
      <Zap className="w-4 h-4" />
      {label || `Power Dial${count ? ` (${count})` : ''}`}
    </button>
  );
}
